import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import notFoundImg from '../images/notfound/page_notice.png';
function NotFound() {
    const history = useHistory();

    const [count, countSet] = useState(10);

    useEffect(() => {
        if (count > 0) {
            setTimeout(() => {
                countSet(count - 1);
            }, 1000);
        } else {
            history.push('/');
        }
    }, [count]);

    return (
        <div id="notFound">
            <p className="img">
                <img src={`${notFoundImg}`} />
            </p>
            <p className="text">
                요청하신 페이지를 찾을 수 없습니다. URL을 확인해주시기 바랍니다.
                <span className="bold">{count}초 후 자동으로 이동합니다</span>
            </p>
            <p className="link">
                <Link to="/">홈으로 이동</Link>
            </p>
        </div>
    );
}

export default NotFound;
